var BASEURL = 'https://api-v2.happay.in/';
export default BASEURL;
